import { apiFetch } from '@/lib/api/client';
import type { AdminUser, NewUser } from '@/types/api';

export function fetchAdminUsers(): Promise<{ items: AdminUser[] }> {
  return apiFetch('/admin/users');
}

export function createUser(body: NewUser): Promise<AdminUser> {
  return apiFetch('/admin/users', { method: 'POST', body });
}

export function updateUser(id: string, changes: Partial<AdminUser>): Promise<AdminUser> {
  return apiFetch(`/admin/users/${id}`, { method: 'PATCH', body: changes });
}
